import { render, staticRenderFns } from "./GenerateBoxes.vue?vue&type=template&id=7119aea6&scoped=true&"
import script from "./GenerateBoxes.vue?vue&type=script&lang=js&"
export * from "./GenerateBoxes.vue?vue&type=script&lang=js&"
import style0 from "./GenerateBoxes.vue?vue&type=style&index=0&id=7119aea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7119aea6",
  null
  
)

export default component.exports